import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from "@angular/core";
import {ClipboardModule} from "@angular/cdk/clipboard";
import {TranslateModule} from "@ngx-translate/core";
import {ToastService} from "src/app/modules/core/services/toast.service";

@Component({
  selector: "app-discussion-copy",
  templateUrl: "./discussion-copy.component.html",
  imports: [ClipboardModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscussionCopyComponent {
  @Input({required: true}) text = "";
  @Output() completed = new EventEmitter<void>();
  private readonly toast = inject(ToastService);

  copied(success: boolean): void {
    this.toast.sendToast({
      text: success ? "DISCUSSION.COPIED" : "DISCUSSION.COPY_ERROR",
      classes: success ? "bg-form-success" : "bg-form-error",
    });
    this.completed.emit();
  }
}
